
export default function QuickDialBar() {
  const quickNumbers = [
    { label: 'Police / Fire / Medical', phone: '911', icon: 'ri-alarm-warning-line', color: 'bg-red-600' },
    { label: 'Poison Control', phone: '(800) 222-1222', icon: 'ri-flask-line', color: 'bg-orange-500' },
    { label: 'Crisis Lifeline', phone: '988', icon: 'ri-mental-health-line', color: 'bg-teal-600' },
    { label: 'Gas Emergency', phone: '(800) 743-5000', icon: 'ri-fire-line', color: 'bg-amber-500' },
  ];

  return (
    <section className="bg-gray-900 py-6">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {quickNumbers.map((item) => (
            <a
              key={item.label}
              href={`tel:${item.phone.replace(/[^0-9]/g, '')}`}
              className="flex items-center gap-4 bg-white/5 hover:bg-white/10 rounded-xl p-4 transition-all group cursor-pointer border border-white/10"
            >
              <div className={`w-12 h-12 ${item.color} rounded-lg flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform`}>
                <i className={`${item.icon} text-white text-xl`}></i>
              </div>
              <div>
                <p className="text-white/70 text-xs font-medium">{item.label}</p>
                <p className="text-white text-lg font-bold tracking-wide">{item.phone}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
